import {Component, ElementRef, inject, input, OnInit} from '@angular/core'
import {FormGroup, ReactiveFormsModule} from '@angular/forms'
import {MatCheckbox} from '@angular/material/checkbox'
import {MatIcon} from '@angular/material/icon'
import {MatError} from '@angular/material/input'
import {MatStepper} from '@angular/material/stepper'
import {SpbAccessibleLinkDirective} from '@sparbanken-syd/sparbanken-syd-theme'
import {RouteService} from '../../services/route.service'

@Component({
  selector: 'spb-welcome',
  templateUrl: './welcome.component.html',
  styleUrl: './welcome.component.scss',
  imports: [ReactiveFormsModule, MatCheckbox, MatIcon, MatError, SpbAccessibleLinkDirective]
})
export class WelcomeComponent implements OnInit {
  public welcomeForm = input.required<FormGroup>()
  public stepper = input.required<MatStepper>()
  protected readonly routeService = inject(RouteService)
  private readonly hostElement = inject(ElementRef)
  public ngOnInit() {
    setTimeout(() => {
      this.hostElement.nativeElement.scrollIntoView({
        behavior: 'smooth',
        block: 'start'
      })
    }, 100)
  }
}
